export default "__VITE_ASSET__DKHk8bBT__"